var React = require('react');

function AsanaCobra (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M30.113,17.164C27.409,22.033,23.938,27,10.5,27\n\tC6.104,27,1,27,1,27v5 M1,30c0,0,9.688,1,18.688,1C31.688,31,33,23.252,33,22c0-2.666-2.383-4.298-4.393-5.802\n\tc-0.44-0.328-1.964-1.467-2.403-1.796c-1.327-0.992-1.599-2.872-0.606-4.199c0.991-1.326,2.871-1.598,4.199-0.606\n\tc0.439,0.329,4.805,3.592,4.805,3.592l-1.423,2.092 M25.055,23.41L29.078,31H32"}));
}

AsanaCobra.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaCobra;

AsanaCobra.default = AsanaCobra;
